
import React from 'react';
import shape1 from '../../../images/shapes/shape_space_3.svg'
import shape2 from '../../../images/shapes/shape_angle_3.webp'
import onze_visie from "../../../images/onze_visie/onze_visie.jpg";
import Bg3 from "../../../images/shapes/shape_title_under_line.svg";
import {Link} from "react-router-dom";

const OnzeVisie = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="faq_section section_decoration" style={{marginBottom: "150px" }}>
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6 order-lg-first">
                        <div className="about_image_2">
                            <div className="image_wrap">
                                <img src={onze_visie} width="800px" alt="Praeventor - Onze Visie" />
                            </div>

                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="about_content">
                            <div className="heading_block mb-0 text-dark">
                                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg3})` }}>
                                    Onze Visie
                                </div>
                                <h2 className="heading_text">
                                    Waar we naartoe <mark>werken</mark>
                                </h2>
                                <p className="heading_description mb-0">
                                    De digitale wereld verandert razendsnel en wij willen daar op een positieve manier invloed op hebben. Onze visie is een toekomst waarin bedrijven van elke grootte veilig kunnen opereren, met de zekerheid dat hun data beschermd is.
                                </p>
                                <div style={{ paddingTop: "40px"}}>
                                    <Link onClick={ClickHandler} className="btn btn-primary" to="/about">
                                        <span className="btn_label" data-text="ONTDEK MEER">ONTDEK MEER</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="Techco Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="Techco Shape Angle" />
            </div>
        </section>
    )
};
export default OnzeVisie;
